import { ComponentType, useEffect } from 'react'

export interface WithTitleProps {
  title?: string // Optional in the props since we're providing it
}

/**
 * HOC that adds a title to a component and sets the document title
 */
export function withTitle<P extends object>(
  Component: ComponentType<P & WithTitleProps>,
  pageTitle: string,
): ComponentType<P> {
  // The returned component doesn't need the title prop since we provide it
  const WithTitleComponent = (props: P) => {
    useEffect(() => {
      document.title = pageTitle
    }, [pageTitle])

    // Pass both the original props and the title prop
    return <Component {...props} title={pageTitle} />
  }

  WithTitleComponent.displayName = `WithTitle(${Component.displayName || Component.name || 'Component'})`

  return WithTitleComponent
}
